export default __webpack_public_path__ + "static/media/info-circle-down.ae195d8c.svg";